import {Storage, USER, ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY} from "base/config";
import {UserService} from "user/service";

function storeTokensInStorage(accessToken, refreshToken) {
    let tokenDataToStore = {};
    Object.defineProperty(tokenDataToStore, ACCESS_TOKEN_KEY, {
        value: accessToken,
        writable: false,
        enumerable: true,
        configurable: false,
    });
    Object.defineProperty(tokenDataToStore, REFRESH_TOKEN_KEY, {
        value: refreshToken,
        writable: false,
        enumerable: true,
        configurable: false,
    });
    Storage.set(USER, JSON.stringify(tokenDataToStore));
}

const AuthService = {
    login(username, password) {
        return UserService.login(username, password)
            .then(tokenData => {
                storeTokensInStorage(tokenData.access, tokenData.refresh);
                let tokenInfo = JSON.parse(atob(tokenData.access.split(".")[1]));
                return tokenInfo.username;
            })
            .catch(error => {
                const jsonError = JSON.parse(error.message);
                throw new Error(jsonError.detail);
            });
    },

    casTokenLogin() {
        return UserService.casTokenLogin()
            .then(tokenData => {
                let tokenInfo = JSON.parse(atob(tokenData.access.split(".")[1]));

                let tokenDataToStore = {};
                Object.defineProperty(tokenDataToStore, ACCESS_TOKEN_KEY, {
                    value: tokenData.access,
                    writable: false,
                    enumerable: true,
                    configurable: false,
                });
                Object.defineProperty(tokenDataToStore, REFRESH_TOKEN_KEY, {
                    value: tokenData.refresh,
                    writable: false,
                    enumerable: true,
                    configurable: false,
                });
                Storage.set(USER, JSON.stringify(tokenDataToStore));

                return tokenInfo.username;
            })
            .catch(error => {
                const jsonError = JSON.parse(error.message);
                throw new Error(jsonError.detail);
            });
    },

    refreshToken() {
        const refresh = AuthService.getRefreshToken();
        if (!refresh) {
            return window.location.replace("/logout");
        }
        return UserService.refresh(refresh).then(tokenData => {
            storeTokensInStorage(tokenData.access, refresh);
            return tokenData;
        });
    },

    logoutCAS(next) {
        UserService.logoutCAS(next);
    },

    logout() {
        return new Promise((resolve, reject) => {
            Storage.remove(USER);
            resolve(true);
        });
    },

    getAccessToken() {
        return AuthService.getUserStoredData(ACCESS_TOKEN_KEY);
    },

    getRefreshToken() {
        return AuthService.getUserStoredData(REFRESH_TOKEN_KEY);
    },

    getUserStoredData(storedDataId) {
        const token = Storage.get(USER);
        if (!token) {
            return null;
        }
        const userStoredData = JSON.parse(token);
        return userStoredData[storedDataId];
    },

    getUsername() {
        const accessToken = this.getAccessToken();
        if (!accessToken) {
            return null;
        }
        let tokenData = JSON.parse(atob(accessToken.split(".")[1]));
        return {
            username: tokenData.username,
            name: tokenData.first_name
                ? `${tokenData.first_name} ${tokenData.last_name}`
                : tokenData.username,
            last_login: tokenData.last_login,
            is_superuser: tokenData.is_superuser,
            roles: tokenData.groups,
            codigo_concello: tokenData.concello,
            cas_login: tokenData.cas_login,
        };
    },
};

export default AuthService;
